import React from "react";
import { Link } from "react-router-dom";

export function CookiePolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-8">
          <Link to="/" className="flex items-center gap-2 mb-6">
            <img src="/uploads/figgy-logo.png" alt="Figgy Logo" className="h-8 w-auto" />
          </Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Cookie Policy</h1>
          <p className="text-gray-600">Effective Date: June 17, 2025</p>
        </div>

        <div className="prose prose-lg max-w-none">
          <p>This Cookie Policy explains how Aleph Studios LLC, doing business as Figgy ("we," "us," or "our"), uses cookies and similar technologies when you visit our website https://www.getfiggy.link or use our web or mobile applications ("Services").</p>
          
          <p>By using our Services, you agree to the use of cookies as outlined in this policy. You may manage your preferences as described below.</p>

          <h2>1. What Are Cookies?</h2>
          <p>Cookies are small text files that are stored on your browser or device when you visit a website or use an app. They serve a variety of functions such as enabling core functionality, improving user experience, analyzing traffic, and supporting personalized content and ads.</p>
          
          <p>We also use similar technologies like pixels, web beacons, local storage, and SDKs (collectively referred to as "cookies").</p>

          <h2>2. Types of Cookies We Use</h2>
          
          <h3>Essential Cookies</h3>
          <p>These cookies are necessary for the Services to function. They enable secure logins, session management, and user authentication. You cannot opt out of these.</p>
          
          <p><strong>Examples:</strong></p>
          <ul>
            <li>Session tracking</li>
            <li>CSRF protection</li>
            <li>Login persistence</li>
          </ul>

          <h3>Performance & Analytics Cookies</h3>
          <p>These cookies help us understand how users interact with our Services, such as which pages are visited and where errors occur. The data collected is aggregated and anonymous.</p>
          
          <p><strong>Examples:</strong></p>
          <ul>
            <li>Google Analytics</li>
            <li>Supabase telemetry (if enabled)</li>
          </ul>

          <h3>Functionality Cookies</h3>
          <p>These remember choices you make (like language or location) and provide enhanced features. They help personalize your experience.</p>
          
          <p><strong>Examples:</strong></p>
          <ul>
            <li>User preference storage</li>
            <li>UI theme settings</li>
          </ul>

          <h3>Advertising & Retargeting Cookies</h3>
          <p>These cookies track browsing behavior across websites to show relevant ads. They may be set by us or trusted third parties like Google Ads or Meta.</p>
          
          <p><strong>Examples:</strong></p>
          <ul>
            <li>Facebook Pixel</li>
            <li>Google Ads tracking</li>
            <li>Campaign attribution cookies</li>
          </ul>

          <h3>Third-Party Cookies</h3>
          <p>Our Services may integrate with third-party services (e.g., Stripe for payments, Twilio for SMS). These services may place their own cookies for functionality or analytics purposes. We do not control their cookie settings.</p>

          <h2>3. Managing Cookies</h2>
          <p>You can manage or disable cookies in several ways:</p>
          
          <ul>
            <li><strong>Browser Settings:</strong> Most browsers allow you to block or delete cookies. Disabling certain cookies may affect functionality.</li>
            <li><strong>Cookie Banner:</strong> When you first access our website, you will see a cookie consent banner that lets you accept or reject non-essential cookies.</li>
            <li><strong>Third-Party Tools:</strong> You can opt out of some advertising cookies using:
              <ul>
                <li><a href="https://optout.aboutads.info/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">https://optout.aboutads.info/</a></li>
                <li><a href="https://www.networkadvertising.org/choices/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">https://www.networkadvertising.org/choices/</a></li>
                <li>Google's Ad Settings page</li>
              </ul>
            </li>
          </ul>

          <h2>4. Do Not Track (DNT)</h2>
          <p>We currently do not respond to "Do Not Track" browser signals due to the absence of a consistent industry standard. If this changes, we will update this policy.</p>

          <h2>5. Updates to This Policy</h2>
          <p>We may update this Cookie Policy to reflect changes in technology, law, or business operations. Updates will be posted on this page with a new effective date. Material changes may be communicated via email or in-app.</p>

          <h2>6. Contact Us</h2>
          <p>If you have questions or concerns about this Cookie Policy, please contact us:</p>
          
          <p>
            Aleph Studios LLC<br />
            5900 Balcones Dr Ste 100<br />
            Austin, TX 78731<br />
            📧 hello@getfiggy.link
          </p>
        </div>
      </div>
    </div>
  );
} 